import React, { ChangeEvent } from "react";

import { CustomSwitch } from "src/app/components/CustomSwitch/CustomSwitch";
import { ReactComponent as CopyIcon } from "src/images/duplicate-gray.svg";
import { ReactComponent as EditIcon } from "src/images/edit-gray.svg";
import { ReactComponent as GridIcon } from "src/images/grid.svg";
import { ReactComponent as TrashCanIcon } from "src/images/trash-can-gray.svg";
import { Dictionary } from "src/types";
import useSortableItem from "src/app/components/VerticalDragAndDropList/useSortableItem";

interface DraggableDictionaryItemProps {
  dictionary: Dictionary;
  handleToggleDictionary: (
    e: ChangeEvent<HTMLInputElement>,
    dictionary: Dictionary,
  ) => void;
  setEditedDictionary: (dictionary: Dictionary) => void;
  handleDuplicateDictionary: (dictionary: Dictionary) => void;
  setDictionaryToRemove: (dictionary: Dictionary) => void;
}

export default function DraggableDictionaryItem({
  dictionary,
  handleToggleDictionary,
  setEditedDictionary,
  handleDuplicateDictionary,
  setDictionaryToRemove,
}: DraggableDictionaryItemProps) {
  const { attributes, listeners, setNodeRef, style } = useSortableItem(
    dictionary.uuid,
  );

  return (
    <li
      ref={setNodeRef}
      style={style}
      className="dictionary-manager__list-item grid--dictionaries-list"
      data-qa-field-name={dictionary.name}
    >
      <div className="dictionary-manager__text">
        <div {...attributes} {...listeners} className="icon-drag">
          <GridIcon />
        </div>

        <div className="dictionary-manager__list-col">
          <div className="dictionary-manager__name">
            <span className="dictionary-manager__name-text">
              {dictionary.name}
            </span>
          </div>
          {dictionary.description && (
            <div className="dictionary-manager__description">
              {dictionary.description}
            </div>
          )}
        </div>
      </div>
      <CustomSwitch
        checked={dictionary.enabled}
        dataAttributes={{
          "data-qa-input": "toggleWsDictionaryActive",
        }}
        onChange={(e) => {
          handleToggleDictionary(e, dictionary);
        }}
      />
      <div className="dictionary-manager__list-actions">
        <button
          className="button-style-reset"
          type="button"
          onClick={() => setEditedDictionary(dictionary)}
          data-qa-button="editWsDictionary"
        >
          <EditIcon />
        </button>
        <button
          type="button"
          className="button-style-reset"
          onClick={() => handleDuplicateDictionary(dictionary)}
          data-qa-button="duplicateWsDictionary"
        >
          <CopyIcon />
        </button>
        <button
          type="button"
          className="button-style-reset"
          onClick={() => setDictionaryToRemove(dictionary)}
          data-qa-button="removeWsDictionary"
        >
          <TrashCanIcon />
        </button>
      </div>
    </li>
  );
}
